module.exports = __webpack_public_path__ + "img/img-works_9.2dcb3ba8.png";